import { ButtonBase, ButtonBaseProps } from "@mui/material"
import { memo } from "react"
import styled from "styled-components"

const StyledButtonBase = styled(ButtonBase)`
  /* hoverstyles: */
  &:hover {
    /* background-color: ${(p) => p.theme.colors.white};
    color: ${(p) => p.theme.colors.black}; */
  }
  /* focusstyles: */
  &:focus {
    /* background-color: ${(p) => p.theme.colors.white};
    color: ${(p) => p.theme.colors.black}; */
    background-color: none;
  }
  &:focus-visible {
    border: 2px dashed white;
    outlineOffset: 2px;
    outline: 3px dashed #0e3487;
  },
`

// exstand button baseprops
type ButtonBaseBlankProps = ButtonBaseProps & {
  children?: React.ReactNode
  className?: string
}

const ButtonBaseBlank = ({
  children,
  className,
  ...props
}: ButtonBaseBlankProps) => {
  return (
    <>
      <StyledButtonBase {...props} className={className} disableRipple={false}>
        {children}
      </StyledButtonBase>
    </>
  )
}

export default memo(ButtonBaseBlank)
